import { configureStore } from '@reduxjs/toolkit';
import categoryTableSlice from './reducers/categoryTableSlice';
import customerTableSlice from './reducers/customerTableSlice';
import enquiryTabelSlice from './reducers/enquiryTabelSlice';
import orderTableSlice from './reducers/orderTableSlice';
import productTableSlice from './reducers/productTableSlice';
import authSlice from './reducers/authSlice';
import appSlice from './reducers/appSlice';
import dashboardSlice from './reducers/dashboardSlice';
import paymentHistorySlice from './reducers/paymentHistorySlice';
import campaignSlice from './reducers/campaignSlice';
import analyticSlice from './reducers/analyticSlice';
import companyslice from './reducers/companySlice';
import paymentSlice from './reducers/paymentSlice';
import templateSlice from './reducers/templateReducer/templateSlice';
import messageSlice from './reducers/ShareMessage/messageSlice';
import enqChatSlice from './reducers/enqChatSlice';
import accountSlice from './reducers/accountSlice';
import ticketTabelSlice from './reducers/ticketTabelSlice';
import usageTabelSlice from './reducers/usageTabelSlice';
import mediaTableSlice from './reducers/mediaTabelSlice';
import multiInputSlice from './reducers/multiInputSlice';
import canvasSlice from './reducers/canvas/canvasSlice';
import notificationSlice from './reducers/notificationSlice';
import aiSlice from './reducers/aiSlice';
import aiKnowledgeSlice from './reducers/aiKnowledgeSlice';
import marketPlaceSlice from './reducers/marketPlaceSlice';
import officenoteSlice from './reducers/officenoteSlice';
import officetimeSlice from './reducers/officetimeSlice';
import whiteLabelSlice from './reducers/whitelabelSlices';
import meetingSlice from './reducers/meetingSlice';
import waba_profile_slice from './reducers/waba-profile/waba-profile-slice';
import salesSupportSlice from './reducers/wca/sales-support/sales-support-slice';
import template_slice_wca from './reducers/wca/template/template-slices';
import campaign_Slice_wca from './reducers/wca/campaign/campaign-slices';
import Setting_Slice_wca from './reducers/wca/setting/setting.slices';
import telegramSlice from './reducers/telegram/telegram-slice';
import tagSlice from './reducers/tagslices';
import metadataSlice from './reducers/MetaData/metadata-slice';
import wcaBotFlowSlice from './reducers/wca/botflow/botflow-slices';
import messageSliceWCA from './reducers/wca/share-message/share-message-slice';
import productSliceWCA from './reducers/wca/product/product-slice';
import supportTicketSlice from './reducers/supportTicketSlice';
import insightSlice from './reducers/wca/insights/insight-slice';
const store = configureStore({
  reducer: {
    productTable: productTableSlice,
    categoryTable: categoryTableSlice,
    orderTable: orderTableSlice,
    enquiryTable: enquiryTabelSlice,
    customerTable: customerTableSlice,
    ticketTable: ticketTabelSlice,
    authenticate: authSlice,
    application: appSlice,
    dashboard: dashboardSlice,
    paymentHistory: paymentHistorySlice,
    campaign: campaignSlice,
    analytic: analyticSlice,
    company: companyslice,
    payment: paymentSlice,
    template: templateSlice,
    shareMessage: messageSlice,
    enqChats: enqChatSlice,
    account: accountSlice,
    media: mediaTableSlice,
    notification: notificationSlice,
    multiInput: multiInputSlice,
    canvas: canvasSlice,
    ai: aiSlice,
    aiKnowledge: aiKnowledgeSlice,
    usageTable: usageTabelSlice,
    marketPlace: marketPlaceSlice,
    officeNote: officenoteSlice,
    officeTime: officetimeSlice,
    whitelabel: whiteLabelSlice,
    meeting: meetingSlice,
    wabaProfile: waba_profile_slice,
    supportTicket: supportTicketSlice,
    wcaEnqChats: salesSupportSlice,
    wcaMessageTemplate: template_slice_wca,
    wcaCampaign: campaign_Slice_wca,
    wcaSettings: Setting_Slice_wca,
    wcaBotFlow: wcaBotFlowSlice,
    telegram: telegramSlice,
    tag: tagSlice,
    metadata: metadataSlice,
    shareMessageWCA: messageSliceWCA,
    productTableWCA: productSliceWCA,
    insight: insightSlice,
  },
});

export default store;
